module.exports = __webpack_public_path__ + "static/img/logo-index.769114e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-index.png
// module id = eWzv
// module chunks = 0